<template>
  <div class="confer-card-menu">
    <v-tooltip bottom light v-if="canCall">
      <template v-slot:activator="{ on }">
        <v-btn @click="$emit('call-room')" class="mr-1 call-room" v-on="on"
          fab x-small dark depressed color="primary" :disabled="confDisabled">
          <v-icon>mdi-phone</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('confr.tooltip.btnCall') }}</span>
    </v-tooltip>
    <v-tooltip bottom light v-if="canInvite">
      <template v-slot:activator="{ on }">
        <v-btn @click="$emit('invite-member')" class="mr-1 invite" v-on="on"
          fab x-small dark depressed color="primary" :disabled="confDisabled">
          <v-icon>mdi-account-plus-outline</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('confr.tooltip.invite') }}</span>
    </v-tooltip>
    <v-tooltip bottom light>
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <v-btn :disabled="!hasCalls || confDisabled" @click="$emit('show-members')"
            fab x-small depressed color="blue-grey">
            <v-icon>mdi-account-group</v-icon>
          </v-btn>
        </span>
      </template>
      <span v-if="hasCalls">{{ $t('confr.tooltip.btnMems') }}</span>
      <span v-else>{{ $t('confr.tooltip.btnNoMember') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'conference-card-title-menu',
  props: {
    confDisabled: {
      type: Boolean,
      default: false,
      required: false
    },
    hasCalls: {
      type: Boolean,
      default: false
    },
    canCall: {
      type: Boolean,
      default: false
    },
    canInvite: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
</style>
